export default __webpack_public_path__ + "static/media/interior-2.797c6b24.jpg";